<template>
  <div>
    <Product></Product>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Product from "../../../../comModule/integralMall/commodity/prodduct/adproduct";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    Product
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped></style>
